import { Provider } from 'mobx-react'
import { Suspense, useState } from 'react'
import { RouterProvider } from 'react-router'
import { observer } from 'mobx-react-lite'
import { ConfigProvider, theme } from 'antd'

import 'antd/dist/reset.css'
import './index.css' 

import store from './stores'
import { router } from './router'
import { GlobalStyles } from './components/GlobalStyle'
import Maintenance from './pages/Maintenance'
import Loading from './components/Loading'
import Stars from './components/Stars'

// --- เรากลับมาใช้ @fontsource แทน Google Fonts เพื่อความเสถียรครับ ---

const App: React.FC = () => {
  const [maintenance] = useState(false)

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm, 
        token: {
          // ฟอนต์จะไปดึงจากที่โหลดไว้ใน index.html อัตโนมัติครับ
          fontFamily: `'Inter', 'IBM Plex Sans Thai', -apple-system, sans-serif`,
          colorPrimary: '#398DF4',
          borderRadius: 12,
        },
        components: {
          Input: {
            colorText: '#1a3055',
            colorTextPlaceholder: '#9ca3af',
          },
        },
      }}
    >
      <Provider store={store}>
        {import.meta.env.VITE_APP_TARGET === 'staging' && (
          <div className="fixed z-[9999] left-1/2 -translate-x-1/2 bg-red-600 top-1 rounded-full text-white px-4 py-1 text-xs font-bold shadow-md pointer-events-none">
            ใช้เพื่อการทดสอบภายในเท่านั้น ห้ามเผยแพร่
          </div>
        )}

        <GlobalStyles />
        
        {/* GLOBAL JWC14 BACKGROUND */}
        <div className="fixed inset-0 z-[-1] overflow-hidden bg-[#398DF4] bg-[linear-gradient(140deg,#4AE3E9_0%,#398DF4_44%,#398DF4_100%)]">
          <Stars />
          
          <img
            src="/J14/Asset/CloudSmallTransparent.svg"
            alt=""
            className="w-[80%] sm:w-[50%] absolute bottom-0 -left-10 sm:-left-30 opacity-60 z-0"
          />
          <img
            src="/J14/Asset/CloudSmallTransparent.svg"
            alt=""
            className="w-[80%] sm:w-[50%] absolute bottom-0 -right-10 sm:-right-30 opacity-60 -scale-x-100 z-0"
          />
        </div>

        <Suspense fallback={<Loading />}>
          {maintenance ? <Maintenance /> : <RouterProvider router={router} />}
        </Suspense>
      </Provider>
    </ConfigProvider>
  )
}

export default observer(App)
